<template>
  <div style="height:100%;width:100%">
    <div v-if="chartConfig.isShowTime==='1'" :style="{width:width,heigth:height,fontSize:fontSize,fontFamily:chartConfig.fontFamily,color:chartConfig.color,
    textAlign:align,verticalAlign:valign,letterSpacing:letterSpacing,fontWeight:chartConfig.fontWeight}">{{ currentTime }}</div>
    <div :style="{width:width,heigth:height,fontSize:fontSizeDate,fontFamily:chartConfig.fontFamilyDate,color:chartConfig.colorDate,
    textAlign:alignDate,letterSpacing:letterSpacingDate,fontWeight:chartConfig.fontWeightDate}"><span v-if="chartConfig.isShowDate==='1'">{{ currentDate }}</span>
      <span v-if="chartConfig.isShowWeek==='1'">星期{{ currentWeek }}</span></div>
  </div>
</template>

<script>
  import fwUtil from 'framework-util'
  const dateUtil = new fwUtil.DateUtil.DateUtil()
  export default {
    props: {
      width: {
        type: String,
        default: '300px'
      },
      height: {
        type: String,
        default: '30px'
      },
      chartConfig: {
        type: Object,
        default: function() {
          return {
            fontSize: 32,
            fontFamily: 'DIN',
            color: '#fff',
            align: 'center',
            verticalAlign: 'middle',
            letterSpacing: 8,
            fontWeight: 'bold',
            isShowTime:'1',
            isShowDate:'1',
            isShowWeek:'1',
            fontSizeDate: 16,
            fontFamilyDate: 'Source Han Sans CN',
            colorDate: '#fff',
            alignDate: 'center',
            verticalAlignDate: 'middle',
            letterSpacingDate: 8,
            fontWeightDate: 300,
          }
        }
      }
    },
    data() {
      return {
        timer: null,
        currentTime: '',
        currentDate: '',
        currentWeek: '',
      }
    },
    computed: {
      letterSpacing() {
        return this.chartConfig.letterSpacing + "px"
      },
      letterSpacingDate() {
        return this.chartConfig.letterSpacingDate + "px"
      },
      fontSize() {
        return this.chartConfig.fontSize + "px"
      },
      fontSizeDate() {
        return this.chartConfig.fontSizeDate + "px"
      },
      align() {
        if (!this.chartConfig.align) {
          return 'left'
        }
        return this.chartConfig.align
      },
      alignDate() {
        if (!this.chartConfig.alignDate) {
          return 'left'
        }
        return this.chartConfig.alignDate
      },
      valign() {
        if (!this.chartConfig.verticalAlign) {
          return 'middle'
        }
        return this.chartConfig.verticalAlign
      }
    },
    mounted() {
      this.clearTimer()
      this.setTimer();
    },
    beforeDestroy() {
      this.clearTimer()
    },
    methods: {
      clearTimer() {
        if (this.timer != null) {
          clearInterval(this.timer)
          this.timer = null
        }
      },
      setTimer() {
        let that = this;
        this.timer = setInterval(() => {
          that.getCurrentDate()
        }, 1000)
      },
      getCurrentDate() {
        var _date = dateUtil.getCurrentDate()
        var dtime = dateUtil.formatDate(_date)
        this.currentTime = dateUtil.format(_date, 'HH:mm:ss')
        this.currentWeek = dateUtil.format(_date, 'W')
        this.currentDate = dateUtil.format(_date, 'yyyy年MM月dd日')
      }
    }

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/text/Datetime.vue